import { useEffect, useState } from 'react'

/**
 * Returns `value` after `delayMs` has elapsed without changes — Story 2.2 AC4
 * (search input debounce ≤150ms).
 *
 * The very first synchronous render returns the initial value immediately,
 * matching the requirement that initial filtering is instant.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    if (delayMs <= 0) {
      setDebounced(value)
      return
    }
    const handle = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(handle)
  }, [value, delayMs])

  return debounced
}
